import * as Cookies from 'js-cookie';
import _ from 'lodash';

$.fn.dataTable.Filters = function (table, options) {
    this.columns = options.columns;

    let api = $(table).DataTable().api();
    let container = $('<div class="mb-3" />');

    for (let column of this.columns) {
        let index = column.index;
        if(index === null) continue;

        column = Object.assign({}, {
            placeholder: 'wszystkie',
            color: 'primary',
            title: api.column(index).title(),
            values: null,
            wasCustom: null,
            regex: '^{value}$'
        }, column);
        column.cookiesIndex = `dt_filters__${$(table).attr('id')}__${index}`;

        column.selected = '';

        let dropdown = $(`<div data-app-filter_column="${index}" class="btn-group" />`);

        let dropdownButton = $(`
            <button id="${$(table).attr('id')}_dd_${index}" data-bs-toggle="dropdown" type="button" class="mb-1 dropdown-toggle btn btn-sm btn-${column.color} me-1">
                ${column.title}: <strong>${column.placeholder}</strong>
            </button>
        `);

        const dropdownElements = $(`<ul class="dropdown-menu" aria-labelledby="${$(table).attr('id')}_dd_${index}" />`);
        dropdown.append(dropdownElements);

        dropdown.append(dropdownButton);
        container.append(dropdown);

        // update dropdown elements
        let firstDraw = true;

        api.on('draw', function() {
            dropdownElements.empty();
            dropdownElements.append(`<li><a class="dropdown-item ${column.selected === "" ? 'active' : ''}" href="#" data-value="">${column.placeholder}</a></li>`);

            let data = api.column(index).data().unique().sort();

            if (!column.values) {
                data.each(function (element) {
                    dropdownElements.append(`<li><a data-value="${_.escape(element)}" class="dropdown-item ${column.selected === element ? 'active' : ''}" href="#">${element}</a></li>`)
                });
            } else {
                for (let value of column.values) {
                    dropdownElements.append(`<li><a data-value="${value.value}" class="dropdown-item ${column.selected === value.value ? 'active' : ''}" href="#">${value.text}</a></li>`)
                }
            }

            if(firstDraw) {
                firstDraw = false;

                if(typeof Cookies.get(column.cookiesIndex) !== 'undefined' && Cookies.get(column.cookiesIndex) !== null) {
                    let element = dropdownElements.find(`a[data-value="${_.escape(Cookies.get(column.cookiesIndex))}"]`);
                    if(element.length === 0) {
                        let elements = dropdownElements.find('a[data-value]');
                        for(let el of elements) {
                            if($(el).data('value') === Cookies.get(column.cookiesIndex)) {
                                element = $(el);
                                break;
                            }
                        }
                    }

                    if(element.length === 0) {
                        Cookies.remove(column.cookiesIndex)
                    } else {
                        element.click()
                    }
                }
            }
        })

        dropdownElements.on('click', 'a', function () {
            if(column.wasCustom) {
                if($.fn.dataTable.ext.search.indexOf(column.wasCustom, 1)) {
                    $.fn.dataTable.ext.search.splice($.fn.dataTable.ext.search.indexOf(column.wasCustom, 1));
                }
                column.wasCustom = null;
            }

            let value = $(this).data('value');
            let text = value === "" ? column.placeholder : value;

            if(column.values && value !== "") {
                text = column.values.find(v => v.value === value).text;
            }

            column.selected = value;

            dropdownButton.find('strong').text(text);
            dropdownElements.find('a.active').toggleClass('active');
            $(this).toggleClass('active');

            Cookies.set(column.cookiesIndex, value);

            if (column.values) {
                let element = column.values.find(val => val.value === value);
                if(element && typeof element.custom != 'undefined') {
                    column.wasCustom = element.custom;

                    $.fn.dataTable.ext.search.push(element.custom);
                    api.draw();
                    return;
                }
            }

            api.column(index)
                .search(value ? column.regex.replaceAll('{value}', value) : '', true, false)
                .draw();
        })

        new bootstrap.Dropdown(dropdownButton[0]);
    }

    return container;
}

$.fn.DataTable.Filters = $.fn.dataTable.Filters;

$.fn.dataTable.ext.feature.push({
    fnInit: function (settings) {
        let table = settings.nTable;
        let api = new $.fn.DataTable.Api(settings);

        if (!$(table).find('th[data-filter]') || (typeof settings.filters != 'undefined')) {
            return;
        }

        let options = Object.assign({}, {columns: []}, api.init().filters)

        let index = 0;
        for (let th of $(table).find('th')) {
            if ($(th).data('filter')) {
                options.columns = [...options.columns, {
                    index,
                    placeholder: $(th).data('filter_placeholder') ?? 'wszystko',
                    color: $(th).data('filter_color') ?? 'primary',
                }]
            }

            index++;
        }

        if (options.columns.length === 0) {
            return;
        }

        return new $.fn.dataTable.Filters(table, options);
    },
    cFeature: 'F'
});
